import * as React from 'react'
import { ReactElement } from 'react'
import { InjuryPanelProps } from './FormContainer'
import { Field, Input } from '@fluentui/react-components'
import BaseCombobox from '../../Combobox/BaseCombobox'

type Props = InjuryPanelProps & {}

const DropdownOptions = ['Ja', 'Nee', 'Onbekend']

export default function MedicalAssistancePanel(props: Props): ReactElement {
    return (
        <div className={props.styles.formRow}>
            <Field label="Ambulance ter plaatse" orientation={props.orientation}>
                <BaseCombobox<string>
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                />
            </Field>
            <Field label="Naar spoedeisende hulp vervoerd" orientation={props.orientation}>
                <BaseCombobox<string>
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                />
            </Field>
            <Field label="Naar huisartsenpost vervoerd" orientation={props.orientation}>
                <BaseCombobox<string>
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                />
            </Field>
            <Field label="Bij huisarts geweest" orientation={props.orientation}>
                <BaseCombobox<string>
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                />
            </Field>
            <Field label="Therapie" orientation={props.orientation}>
                <Input placeholder="Soort therapie" />
            </Field>
            <Field label="Specialist" orientation={props.orientation}>
                <Input placeholder="Discipline" />
            </Field>
            <Field label="Ziekenhuisopname" orientation={props.orientation}>
                <BaseCombobox<string>
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                />
            </Field>
            <Field label="Revalidatiekliniek opname" orientation={props.orientation}>
                <BaseCombobox<string>
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                />
            </Field>
        </div>
    )
}
